import Collection from "../../../data-structures/collection";
import Workspace from "./workspace";
import ProjectSession from "../../project/project-session";
import {NavigationButtonPosition} from "../../navigation/@const";


export class Workspaces extends Collection<Workspace> {


    constructor() {
        super()

        this.initFromSession()

    }

    initFromSession() {

        _.map(gd.session.projects.workspaces, (project:ProjectSession)=>{
            if (!this.getByProjectId(project.id)) {
                this.add(new Workspace(project))
            }
        })
    }

    getByProjectId(id:ID) {
        return this.get('workspace-'+id)
    }

    getByProject(project:ProjectSession):Workspace|null {
        return this.get('workspace-'+project.id)
    }

    removeByProject(project:ProjectSession) {
        return this.remove('workspace-'+project.id)
    }

    get inNavigationPanel():Workspace[] {

        return _.filter(this.models, (workspace) => {
            return workspace.navigation.position === NavigationButtonPosition.TOP
        })

    }




}